import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/pages/Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize EmailJS with public key from environment variables
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);

    // Prepare email parameters
    const templateParams = {
      to_email: 'hzlandscapingmarin@gmail.com',
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone || 'Not provided',
      service: formData.service,
      message: formData.message
    };

    // Send email using EmailJS with credentials from environment variables
    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    )
      .then((response) => {
        console.log('Email sent successfully!', response);
        setSubmitted(true);
        // Reset the form
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
        // Hide the success message after 5 seconds
        setTimeout(() => setSubmitted(false), 5000);
      })
      .catch((err) => {
        console.error('Failed to send email:', err);
        setError(true);
        setTimeout(() => setError(false), 5000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="contact">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>Have a question or ready to get started? We'd love to hear from you!</p>
      </div>

      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="info-item">
              <h3>Email</h3>
              <p>hzlandscapingmarin@gmail.com</p>
            </div>
            <div className="info-item">
              <h3>Phone</h3>
              <p>(415) 305-4327</p>
            </div>
            <div className="info-item">
              <h3>Service Area</h3>
              <p>Local area and surrounding communities</p>
            </div>
            <div className="info-item">
              <h3>Hours</h3>
              <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
              <p>Saturday: 9:00 AM - 4:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <h2>Send us a Message</h2>

            {submitted && (
              <div className="success-message">
                ✓ Thank you for your message! We'll get back to you soon.
              </div>
            )}

            {error && (
              <div className="error-message">
                ✗ Failed to send message. Please try again or call us directly.
              </div>
            )}

            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(555) 123-4567"
              />
            </div>

            <div className="form-group">
              <label htmlFor="service">Service of Interest *</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select a service</option>
                <option value="planting">Planting</option>
                <option value="fence">Fence Installation</option>
                <option value="decking">Decking</option>
                <option value="maintenance">Maintenance Plans (Weekly/Monthly)</option>
                <option value="consultation">General Consultation</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Tell us about your project or question..."
                rows="5"
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
